module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0151.jpg?v=7bead5a4";